import angular from 'angular';

import { CartDirective } from './directives/cartDirective';
import { DiningOptionComponent } from './directives/dining_option.component';
import { DiningOptionDefaultComponent } from './directives/dining_option.default.component';
import { DiningOptionVariantComponent } from './directives/dining_option.variant.component';
import { InitialTimeDirective } from './directives/initialTimeDirective';
import { ModifyOrderComponent } from './directives/modify_order.component';
import { OrderDateTimeDirective } from './directives/orderDateTimeDirective';
import { RestaurantInfoDirective } from './directives/restaurantInfoDirective';
import { SchedulesDirective } from './directives/schedulesDirective';

import { AvailabilitiesFactory } from './factories/availabilitiesFactory';
import { BrowserDetectService } from './services/browserDetectService';

//controllers imported for THURSDAY_DATE_STRING
import { DiningOptionController } from './controllers/dining_option.controller';
import { OrderDateTimeController } from './controllers/orderDateTimeController';
import { SummaryController } from './controllers/summaryController';

export const SummaryModule = angular
    .module('oo.order.summary', [])
    .directive('cart', CartDirective)
    .component('diningOption', DiningOptionComponent)
    .component('diningOptionDefault', DiningOptionDefaultComponent)
    .component('diningOptionVariant', DiningOptionVariantComponent)
    .component('modifyOrder', ModifyOrderComponent)
    .directive('orderDateTime', OrderDateTimeDirective)
    .directive('restaurantInfo', RestaurantInfoDirective)
    .directive('schedules', SchedulesDirective)
    .factory('availabilitiesFactory', AvailabilitiesFactory)
    .service('browserDetectService', BrowserDetectService)
    .directive('initialTime', InitialTimeDirective)

    .controller('DiningOptionController', DiningOptionController)
    .controller('OrderDateTimeController', OrderDateTimeController)
    .controller('SummaryController', SummaryController)
    .name;
